import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';

export const ONBOARDING_STATUS_PILL_CLASS = {
  onboardingSent: 'bg-sky-50 text-sky-900',
  onboardingSubmitted: 'bg-indigo-50 text-indigo-900',
  paSigned: 'bg-violet-50 text-violet-900',
  onboardingCompleted: 'bg-teal-50 text-teal-900',
  onboardingDenied: 'bg-red-50 text-red-900'
};

export default function OnboardingStatusPill({ groupKey, label }) {
  const cls =
    ONBOARDING_STATUS_PILL_CLASS[groupKey] || 'bg-gray-100 text-gray-700';
  return (
    <span
      className={cn(
        'inline-flex max-w-[min(100%,220px)] truncate rounded-full px-2 py-0.5 text-center text-xs font-medium',
        cls
      )}
      title={label}
    >
      {label}
    </span>
  );
}

OnboardingStatusPill.propTypes = {
  groupKey: propTypes.string.isRequired,
  label: propTypes.string.isRequired
};
